namespace Solovis.Reports.Parts.Tables.DataTableHelpers {


    /*
     * options:
     *  sortBy: array of sortByEntry
     *  sorts: array of sort settings passed into DataTableControl settings
     * 
     * {sortByEntry} is a column id or:
     *      id: column id,
     *      desc: true/false (false for ascending, true for descending order)
     */
    export class SortManager {

        public tableControl: Solovis.Reports.Parts.Tables.DataTableControl;
        public _sortsSettings;
        public _sorts;        
        public _sortIdToSortMap;
        public _sortBy;
        public _isStickySortCallback: (sortId: any, sortByEntry?: any) => boolean;

        constructor(options) {
            this.tableControl = options.tableControl;

            var self = this;

            this.tableControl = options.tableControl;

            this._sortsSettings = Solovis.isNotNull(options.sorts) ? options.sorts : null;
            this._isStickySortCallback = options.isStickySortCallback;

            this._sorts = [];
            this._sortIdToSortMap = {};

            this._sortBy = [];
            this.updateSortByList(options.sortBy);
        }

        /*
         * Update the list of sorts that will be used to do the composite sort.
         * @param sortBy - list of { id: "sortId", desc: bool },
         * @param commandSource - indicates who triggered event to prevent infinite notification loops in certain situations.
         */
        public updateSortByList(sortBy, commandSource?: string) {
            var newSortByList = [];

            $(sortBy).each(function (i, entry: any) {
                var sortByEntry;
                if (typeof entry == "string") {
                    sortByEntry = {
                        id: entry
                    };
                }
                else {
                    sortByEntry = entry;
                }

                newSortByList.push(sortByEntry);
            });

            this._sortBy = newSortByList;           

            this.notifySortByChanged(commandSource);
        }

        public alsoSortBy(sortByEntry) {
            this._sortBy.push(sortByEntry);

            this.notifySortByChanged();
        }

        public toggleSortDirection(sortId, commandSource?: string) {
            var currentItems = this.getSortByList();
            var newSortByList = _.map(currentItems, function (item) {
                if (item.id === sortId) {
                    return { id: item.id, desc: !item.desc };
                }
                else {
                    return item;
                }
            });

            this.updateSortByList(newSortByList, commandSource);
        }

        public removeSortById(sortId, commandSource?: string) {
            var currentItems = this.getSortByList();
            var newSortByList = _.filter(currentItems, function (item) {
                if (item.id !== sortId) {                    
                    return true;
                }
            });

            this.updateSortByList(newSortByList, commandSource);
        }

        public notifySortByChanged(commandSource?: string) {
            $(this).trigger("sortByChanged", { commandSource: commandSource });
        }

        public notifySortsChanged() {
            $(this).trigger("sortsChanged");
        }

        public getSortByList() {
            var sortByList = [];

            $(this._sortBy).each(function (i, entry: any) {
                var entryCopy = {
                    id: entry.id,
                    desc: Solovis.isNotNull(entry.desc) ? entry.desc : null
                };

                sortByList.push(entryCopy);
            });

            return sortByList;
        }

        /**
         * Sticky sorts are ones that should stick around after switching to a new sort via column sort click.
         */
        public getStickySortByList() {
            let self = this;
            let sortByList = [];

            if (this._isStickySortCallback) {
                $(this._sortBy).each(function (i, entry: any) {
                    if (self._isStickySortCallback(entry.id, entry)) {
                        let entryCopy = {
                            id: entry.id,
                            desc: Solovis.isNotNull(entry.desc) ? entry.desc : null
                        };

                        sortByList.push(entryCopy);
                    }
                });
            }

            return sortByList;
        }

        public getSortById(id) {
            if (this._sortIdToSortMap[id])
                return this._sortIdToSortMap[id];

            return null;
        }

        public getAvailableSorts() {
            return this._sorts.slice(0);
        }

        /**
         * Returns "asc"/"desc" depending on current sort order, or null if not part of current sort.
         * @param id
         */
        public getCurrentSortOrderForId(id) {            
            var sortByEntry = _.find(this._sortBy, function (entry: any) { return entry.id == id });
            if (sortByEntry) {
                return sortByEntry.desc ? "desc" : "asc";
            }

            return null;
        }


        public updateSorts() {
            var self = this;

            var sorts = [];
            var sortIdToSortMap = {};

            var sortSourceList;
            if (typeof this._sortsSettings == "function") {
                sortSourceList = this._sortsSettings.call(this.tableControl);
            }
            else if (this._sortsSettings) {
                sortSourceList = this._sortsSettings;
            }
            else {
                sortSourceList = this.getDefaultSorts();
            }

            $(sortSourceList).each(function (i, sort: any) {
                // Setup getter.
                var fieldGetter = null;
                if (typeof sort.field == "string") {
                    fieldGetter = function (row) {
                        return Solovis.resolveObject(sort.field, row);
                    };
                }
                else if (typeof sort.field == "function") {
                    fieldGetter = sort.field;
                }

                var compositeGetter = function (row) {
                    if (row._backingRow) {
                        return fieldGetter(row._backingRow);
                    }
                    else if (row._groupId == sort.id) {
                        return row._groupRep;
                    }
                    else if (row._groupTotals && typeof row._groupTotals[sort.id] != "undefined") {
                        return row._groupTotals[sort.id];
                    }
                    else {
                        return fieldGetter(row);
                    }
                };

                if (typeof sort.converter == "function") {
                    sort.getter = function (row) {
                        var value = compositeGetter(row);
                        return sort.converter(value);
                    };
                }
                else {
                    sort.getter = compositeGetter;
                }

                sorts.push(sort);
                sortIdToSortMap[sort.id] = sort;
            });

            this._sorts = _.sortBy(sorts, 'label');
            this._sortIdToSortMap = sortIdToSortMap;

            this.notifySortsChanged();
        }


        public getDefaultSorts(sortOptions?) {
            var self = this;

            var includeIsGroupRowSort = false;
            if (sortOptions) {
                includeIsGroupRowSort = sortOptions.includeIsGroupRowSort ? true : false;
            }

            var sorts = [];

            var standardComparer = function (value1, value2) {
                if (Solovis.isNull(value1)) {
                    if (Solovis.isNull(value2)) {
                        return 0;
                    }
                    else {
                        return -1;
                    }
                }
                else if (Solovis.isNull(value2)) {
                    return 1;
                }

                if (value1 < value2) {
                    return -1;
                }
                else if (value1 > value2) {
                    return 1;
                }

                return 0;
            };

            var caseInsensitiveStringComparer = function (value1, value2) {
                if (Solovis.isNull(value1)) {
                    if (Solovis.isNull(value2)) {
                        return 0;
                    }
                    else {
                        return -1;
                    }
                }
                else if (Solovis.isNull(value2)) {
                    return 1;
                }

                if (typeof value1 != "string")
                    value1 = value1.toString();
                if (typeof value2 != "string")
                    value2 = value2.toString();

                value1 = value1.toLowerCase().trim();
                value2 = value2.toLowerCase().trim();

                if (value1 < value2) {
                    return -1;
                }
                else if (value1 > value2) {
                    return 1;
                }

                return 0;
            };

            var boolComparer = function (a, b) {
                var aValue = a ? 1 : 0;
                var bValue = b ? 1 : 0;
                return aValue - bValue;
            };

            var colSortLabelGetter = function (col) {
                var label = col.label;
                if (col.superHeaders && col.superHeaders.length > 0) {
                    for (var i = 0; i < col.superHeaders.length; i++) {
                        label = col.superHeaders[i] + " : " + label;
                    }
                }

                return label;
            };

            if (includeIsGroupRowSort) {
                sorts.push({
                    id: "isGroupRow",
                    label: "Is Group Row",
                    field: function (row) { return row._groupId ? true : false; },
                    desc: false,
                    comparer: boolComparer,
                    sortDataType: "bool"
                });
            }

            var columnList = this.tableControl.columnSet.getColumnList();
            $(columnList).each(function (i, colObject: any) {
                var col = colObject.definition;

                var dataType = col.dataType ? col.dataType : null;
                if (dataType === "currency" || dataType === "number" || dataType === "percentage" || dataType === "dayId" || dataType === "utcTimestamp") {
                    sorts.push({
                        id: col.id,
                        label: colSortLabelGetter(col),
                        field: col.field,
                        desc: true,
                        comparer: standardComparer,
                        sortDataType: "number"
                    });
                }
                else if (dataType === "integer") {
                    sorts.push({
                        id: col.id,
                        label: colSortLabelGetter(col),
                        field: col.field,
                        desc: false,
                        comparer: standardComparer,
                        sortDataType: "number"
                    });
                }
                else if (dataType === "string") {
                    sorts.push({
                        id: col.id,
                        label: colSortLabelGetter(col),
                        field: col.field,
                        desc: false,
                        comparer: caseInsensitiveStringComparer,
                        sortDataType: "string"
                    });
                }
                else if (dataType === "bool") {
                    sorts.push({
                        id: col.id,
                        label: colSortLabelGetter(col),
                        field: col.field,
                        desc: true,
                        comparer: boolComparer,
                        sortDataType: "bool"
                    });
                }
                else if (dataType === "resourceId") {
                    if (self.tableControl.modelEnvironment) {
                        sorts.push({
                            id: col.id,
                            label: colSortLabelGetter(col),
                            field: col.field,
                            converter: function (rawValue) {
                                var label = self.tableControl.modelEnvironment.labelHelper.getResourceLabel(rawValue);
                                return label;
                            },
                            desc: false,
                            comparer: caseInsensitiveStringComparer,
                            sortDataType: "string"
                        });
                    }
                }
                else if (dataType === "entityId") {
                    if (self.tableControl.modelEnvironment) {
                        sorts.push({
                            id: col.id,
                            label: colSortLabelGetter(col),
                            field: col.field,
                            converter: function (rawValue) {
                                var label = self.tableControl.modelEnvironment.labelHelper.getEntityLabel(rawValue);
                                return label;
                            },
                            desc: false,
                            comparer: caseInsensitiveStringComparer,
                            sortDataType: "string"
                        });
                    }
                }
                else if (dataType === "investmentId") {
                    if (self.tableControl.modelEnvironment) {
                        sorts.push({
                            id: col.id,
                            label: colSortLabelGetter(col),
                            field: col.field,
                            converter: function (rawValue) {
                                var label = self.tableControl.modelEnvironment.labelHelper.getInvestmentLabel(rawValue);
                                return label;
                            },
                            desc: false,
                            comparer: caseInsensitiveStringComparer,
                            sortDataType: "string"
                        });
                    }
                }
                else if (dataType === "currencyId") {
                    if (self.tableControl.modelEnvironment) {
                        sorts.push({
                            id: col.id,
                            label: colSortLabelGetter(col),
                            field: col.field,
                            converter: function (rawValue) {
                                var label = self.tableControl.modelEnvironment.labelHelper.getCurrencyCodeLabel(rawValue);
                                return label;
                            },
                            desc: false,
                            comparer: caseInsensitiveStringComparer,
                            sortDataType: "string"
                        });
                    }
                }
                else if (dataType === "propertyDefinitionId") {
                    if (self.tableControl.modelEnvironment) {
                        sorts.push({
                            id: col.id,
                            label: colSortLabelGetter(col),
                            field: col.field,
                            converter: function (rawValue) {
                                var label = self.tableControl.modelEnvironment.labelHelper.getPropertyDefinitionLabel(rawValue);
                                return label;
                            },
                            desc: false,
                            comparer: caseInsensitiveStringComparer,
                            sortDataType: "string"
                        });
                    }
                }
                else if (dataType === "tagId") {
                    if (self.tableControl.modelEnvironment && col.tagSetId) {
                        sorts.push({
                            id: col.id,
                            label: colSortLabelGetter(col),
                            field: col.field,
                            converter: function (rawValue) {
                                var tagSet = self.tableControl.modelEnvironment.tagSets.tryGetById(col.tagSetId);
                                if (tagSet) {
                                    var tag = tagSet.tryGetTagById(rawValue);
                                    if (tag) {
                                        return tag.label;
                                    }
                                }
                                else {
                                    return rawValue;
                                }
                            },
                            desc: false,
                            comparer: caseInsensitiveStringComparer,
                            sortDataType: "string"
                        });
                    }
                }
                else if (dataType === "valueTypeId") {
                    sorts.push({
                        id: col.id,
                        label: colSortLabelGetter(col),
                        field: col.field,
                        converter: function (rawValue) {
                            return Solovis.Reports.Formatter.getValueTypeString(rawValue);
                        },
                        desc: false,
                        comparer: caseInsensitiveStringComparer,
                        sortDataType: "string"
                    });
                }
            });

            return sorts;
        }


        public isSortingEnabled() {
            if (this._sortBy && this._sortBy.length > 0) {
                return true;
            }

            return false;
        }

        public sortRows(rowList) {
            var self = this;
            var sortList = [];

            $(this._sortBy).each(function (i, sortByEntry: any) {
                if (self._sortIdToSortMap[sortByEntry.id]) {
                    var sortObject = self._sortIdToSortMap[sortByEntry.id];

                    sortList.push({
                        sortObject: sortObject,
                        desc: Solovis.isNotNull(sortByEntry.desc) ? sortByEntry.desc : (sortObject.desc ? true : false)
                    });
                }
            });

            this._internalSortRows(rowList, sortList);
        }

        public _internalSortRows(rowList, sortList) {
            if (!rowList) {
                return;
            }

            var self = this;

            rowList.sort(function (rowA, rowB) {
                for (var i = 0; i < sortList.length; i++) {
                    var sort = sortList[i];
                    var sortObject = sort.sortObject;

                    var a = sortObject.getter(rowA);
                    var b = sortObject.getter(rowB);
                    var diff = sortObject.comparer(a, b);

                    if (diff < 0) {
                        return sort.desc ? 1 : -1;
                    }
                    else if (diff > 0) {
                        return sort.desc ? -1 : 1;
                    }
                }

                return 0;
            });

            $(rowList).each(function (i, row: any) {
                // NOTE: We do not sort sub-rows because those should always be displayed in the order they are created.
                if (row._rows && !row._subRowReplacement) {
                    self._internalSortRows(row._rows, sortList);
                }
            });
        };

    }
}

